var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNationalPolitics = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Presentation-Audience--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Presentation Audience Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.24 18.35a2.85 2.85 0 1 0 2.85 -2.85 2.85 2.85 0 0 0 -2.85 2.85Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.69 21.2a2.85 2.85 0 1 0 -2.85 -2.85 2.85 2.85 0 0 0 2.85 2.85Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.46 18.35a2.85 2.85 0 1 0 2.85 -2.85 2.86 2.86 0 0 0 -2.85 2.85Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.39 23.19a5.15 5.15 0 0 0 -4 -1.93 5.17 5.17 0 0 0 -3.48 1.34 0.24 0.24 0 0 1 -0.33 0 5.35 5.35 0 0 0 -7.08 0 0.24 0.24 0 0 1 -0.33 0 5.17 5.17 0 0 0 -3.48 -1.34 5.15 5.15 0 0 0 -4 1.93 0.51 0.51 0 0 0 -0.06 0.53A0.5 0.5 0 0 0 1 24h22a0.5 0.5 0 0 0 0.45 -0.28 0.51 0.51 0 0 0 -0.06 -0.53Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.64 9.5h6.73a0.51 0.51 0 0 0 0.4 -0.2 0.53 0.53 0 0 0 0.08 -0.44 4 4 0 0 0 -2.53 -2.65 3.25 3.25 0 1 0 -2.62 0 4.05 4.05 0 0 0 -2.54 2.65 0.53 0.53 0 0 0 0.08 0.44 0.51 0.51 0 0 0 0.4 0.2Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 12a1 1 0 0 0 1 1h0.48a0.25 0.25 0 0 1 0.24 0.2L7 14.7a1 1 0 0 0 2 -0.4l-0.2 -1a0.23 0.23 0 0 1 0.05 -0.21A0.25 0.25 0 0 1 9 13h6a0.25 0.25 0 0 1 0.19 0.09 0.23 0.23 0 0 1 0.05 0.21l-0.2 1a1 1 0 0 0 2 0.4l0.3 -1.5a0.25 0.25 0 0 1 0.24 -0.2H18a1 1 0 0 0 0 -2H6a1 1 0 0 0 -1 1Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNationalPolitics);
export default ForwardRef;